import { capturePosthogEvent, getTextColorBasedOnBgColor } from '@/helpers';
import { useCampaignTagsStore } from '@/stores/campaigns/useCampaignTagsStore';
import { useCampaignTagModalsStore } from '@/stores/campaigns/useCampaignTagModalsStore';
import { Button, Flex, Icon } from '@alpine-iq/ui-library';
import { Tag } from '@alpine-iq/ui-library';
import React from 'react';
import CampaignTagMore from './CampaignTagMore';

export default function CampaignTagsRender(props: { campaignID: string; tags: string[] }) {
	const { loaded, tags } = useCampaignTagsStore();
	const { openRemoveTagModal, openTagInputModal } = useCampaignTagModalsStore();
	const buttonRef = React.useRef<HTMLDivElement>(null);

	const renderedTags = React.useMemo(() => {
		if (!loaded) return null;
		const renderedTags = props.tags?.map((tagID) => {
			const tag = tags[tagID];
			const defaultColor = '#e2e6ed';
			const backgroundColor = tag?.color ?? defaultColor;
			const color = getTextColorBasedOnBgColor(backgroundColor);

			if (!tag) return null;

			return (
				<Tag
					key={tagID}
					size="small"
					className="campaign-tag"
					style={{
						backgroundColor,
						borderColor: backgroundColor,
						color,
					}}
					css={`
						position: relative;
						padding: 4px 8px;
						transition:
							min-width,
							width,
							max-width 0.2s ease-in-out;

						.campaign-tag-more {
							position: absolute;
							right: 0;
							display: none;
						}

						&:hover {
							min-width: 50px;

							.campaign-tag-more {
								max-width: 100%;
								display: flex;
								padding: 0px 4px 0px 8px;
								background-color: ${backgroundColor};
							}
						}
					`}
				>
					<Flex
						align="center"
						gap="4"
					>
						<span style={{ color }}>{tag.name}</span>

						<Flex
							className="campaign-tag-more"
							align="center"
							gap="4"
						>
							<CampaignTagMore
								tag={tag}
								color={color}
							/>
							<Flex
								center
								style={{
									cursor: 'pointer',
								}}
								onClick={() => {
									openRemoveTagModal(tagID, props.campaignID);
									capturePosthogEvent('Campaign Tag - Prompt Remove', {
										campaignID: props.campaignID,
										tagID,
									});
								}}
							>
								<Icon
									type="CLOSE_X"
									color={color}
									height={16}
									width={16}
								/>
							</Flex>
						</Flex>
					</Flex>
				</Tag>
			);
		});

		return renderedTags;
	}, [props.tags, tags, loaded, props.campaignID]);

	return (
		<>
			<Flex
				justify="space-between"
				align="center"
			>
				<Flex
					align="center"
					gap="4"
					style={{
						maxWidth: '100%',
					}}
				>
					{renderedTags}
				</Flex>
				<Flex
					center
					className="campaign-tag-input-container"
					ref={buttonRef}
				>
					<Button
						round
						icon="DEAL_NEW"
						size="small"
						onClick={() => {
							openTagInputModal(props.campaignID, props.tags);
							capturePosthogEvent('Campaign Tag - Prompt Add to Campaign', {
								campaignID: props.campaignID,
							});
						}}
					/>
				</Flex>
			</Flex>
		</>
	);
}
